export default __webpack_public_path__ + "static/media/sample.6bbc5742.pdf";